"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileData = void 0;
const types_1 = require("./types");
class ProfileData {
    static getPutRequest(data, userProfile, lotteryId) {
        var _a, _b, _c, _d, _e, _f;
        if (data.address) {
            data.address.id = ((_c = (_b = (_a = userProfile.addresses) === null || _a === void 0 ? void 0 : _a.filter(x => x.addressTypeId === types_1.AddressType.HOME)) === null || _b === void 0 ? void 0 : _b.map(x => x.id)) === null || _c === void 0 ? void 0 : _c[0]) || null;
        }
        let phones = null;
        const phoneId = ((_f = (_e = (_d = userProfile.phones) === null || _d === void 0 ? void 0 : _d.filter(p => { var _a, _b; return p.phoneTypeId === types_1.PhoneType.MOBILE && (((_b = (_a = p.phone) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0; })) === null || _e === void 0 ? void 0 : _e.sort((x, y) => y.id - x.id).map(x => x.id)) === null || _f === void 0 ? void 0 : _f[0]) || null;
        if (!!data.phone || !!phoneId) {
            phones = [
                {
                    id: phoneId,
                    phone: data.phone
                }
            ];
        }
        if (data.address && data.apartmentNumber) {
            data.address.apartmentNumber = data.apartmentNumber;
        }
        return {
            id: userProfile.id,
            login: userProfile.login,
            email: data.email,
            firstName: data.firstName,
            lastName: data.lastName,
            gender: data.gender,
            birthDate: data.dateOfBirth,
            addresses: [data.address],
            phones,
            lotteryId,
            sourceKey: userProfile.sourceKey
        };
    }
    static getPutRequestBilling(data, userProfile, lotteryId) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (data.address) {
            data.address.addressTypeId = types_1.AddressType.BILLING;
            data.address.id = ((_c = (_b = (_a = userProfile.addresses) === null || _a === void 0 ? void 0 : _a.filter(x => x.addressTypeId === types_1.AddressType.BILLING)) === null || _b === void 0 ? void 0 : _b.map(x => x.id)) === null || _c === void 0 ? void 0 : _c[0]) || null;
        }
        const phones = ((_f = (_e = (_d = userProfile.phones) === null || _d === void 0 ? void 0 : _d.filter(x => x.phoneTypeId === types_1.PhoneType.BILLING)) === null || _e === void 0 ? void 0 : _e.map(x => {
            var _a;
            return [
                {
                    id: x.id,
                    phone: (_a = data.phone) === null || _a === void 0 ? void 0 : _a.replace(/\D/g, ''),
                    phoneTypeId: types_1.PhoneType.BILLING
                }
            ];
        })) === null || _f === void 0 ? void 0 : _f[0]) || [
            {
                phone: (_g = data.phone) === null || _g === void 0 ? void 0 : _g.replace(/\D/g, ''),
                phoneTypeId: types_1.PhoneType.BILLING
            }
        ];
        return {
            id: userProfile.id,
            login: userProfile.login,
            email: userProfile.email,
            firstName: userProfile.firstName,
            lastName: userProfile.lastName,
            birthDate: userProfile.birthDate,
            addresses: [data.address],
            phones: data.phone ? phones : userProfile.phones,
            lotteryId,
            sourceKey: userProfile.sourceKey
        };
    }
}
exports.ProfileData = ProfileData;
//# sourceMappingURL=ProfileData.js.map